@layer components {
  .results {
    --heading-height: calc(var(--font-size-large) * 1.5 + 2 * var(--space-small));
    display: flex;
    flex-direction: column;
    gap: var(--space-medium);
  }

  .section {
    display: flex;
    flex-direction: column;
    gap: var(--space-small);
    padding: var(--space-small);
  }

  .label {
    margin: 0;
    font-size: 16px;
    font-weight: inherit;
    opacity: 0.6;
  }

  .chips {
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
    padding: 0 var(--space-small);

    .section & {
      padding: 0;
    }
  }

  .summary {
    padding: 0 var(--space-small);
    font-size: 16px;
    opacity: 0.6;

    &:empty {
      display: none;
    }
  }

  .heading {
    position: sticky;
    top: var(--controls-height);
    z-index: 1;
    display: flex;
    align-items: baseline;
    gap: var(--space-small);
    background-color: var(--ocean);
    margin: 0;
    padding: var(--space-small);
    font-size: var(--font-size-large);
    font-weight: inherit;
  }

  .count {
    font-size: 16px;
    opacity: 0.6;
  }

  .result {
    display: flex;
    align-items: flex-start;

    /* Przewijanie do wyniku z fokusem zostawia miejsce na przyklejone panele i nagłówek księgi. */
    > * {
      scroll-margin-top: calc(var(--controls-height) + var(--heading-height));
      scroll-margin-bottom: calc(var(--buttons-height) + var(--space-medium));
    }

    /* Obramowanie fokusu do środka, żeby nagłówek księgi nie zakrywał go przy pierwszym wyniku. */
    :focus-visible {
      outline-offset: -2px;
    }
  }

  .match {
    flex: 1;

    &::before {
      min-width: 45px;
    }
  }

  .open {
    flex-shrink: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 36px;
    height: 47px;
    border-radius: var(--radius);
    opacity: 0.5;
    transition-property: background-color, opacity;
    transition-duration: var(--duration);
    transition-timing-function: var(--easing);

    svg {
      width: 18px;
    }

    &:hover, &:focus-visible {
      background-color: var(--blue);
      opacity: 1;
    }
  }

  .sentinel {
    height: 1px;
  }
}
